import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';
import Radio, { RadioProps } from '@mui/material/Radio';

export const RadioToggle = (
  props: RadioProps & {
    label: FormControlLabelProps['label'];
  },
) => {
  return (
    <FormControlLabel
      value={props.value}
      label={props.label}
      sx={{ fontWeight: 500 }}
      control={<Radio {...props} color="success" />}
    />
  );
};
